module.exports = require('./helpers/bundle-url').getBundleURL('hkxlb') + "spiderman.e2295677.png";